import { Parameters, BadgeConfig } from '../types';

/**
 * Extracts business-related parameters with defaults
 */
export const extractBusinessParameters = (parameters: Parameters) => {
  return {
    forceDiscount: (parameters['force_business_discount']?.value as boolean) ?? false,
    partialDiscountAllowed: (parameters['partial_discount_allowed']?.value as boolean) ?? true,
    defaultBannerUrl: (parameters['default_business_banner_url']?.value as string) || ''
  };
};

/**
 * Extracts badge configuration for home page
 */
export const extractBadgeConfiguration = (parameters: Parameters): BadgeConfig[] => {
  const badgeSectionsRaw = (parameters['home_page_badge_sections']?.value as string) || '[]';
  
  try {
    return JSON.parse(badgeSectionsRaw);
  } catch (e) {
    // Return empty array if JSON parsing fails
    return [];
  }
};

/**
 * Extracts featured businesses grouping preference
 */
export const extractFeaturedGrouping = (parameters: Parameters): boolean => {
  return (parameters['featured_businesses_group_by_category']?.value as boolean) ?? false;
};

/**
 * Extracts time format preference
 */
export const extractTimeFormat = (parameters: Parameters): '12' | '24' => {
  const format = (parameters['time_display_format']?.value as string) || '12';
  return format as '12' | '24';
};

/**
 * Extracts category browsing enabled state
 */
export const extractCategoryBrowsing = (parameters: Parameters): boolean => {
  return (parameters['category_browsing']?.value as boolean) ?? false;
};

/**
 * Extracts allowed location
 */
export const extractAllowedLocation = (parameters: Parameters): string => {
  return (parameters['allowed_location']?.value as string) || 'Leicester';
};

/**
 * Extracts discount display settings
 */
export const extractDiscountSettings = (parameters: Parameters) => {
  return {
    shouldDisplayDiscountCode: (parameters['should_display_discount_code']?.value as boolean) ?? false,
    forceDiscount: (parameters['force_business_discount']?.value as boolean) ?? false,
    partialDiscountAllowed: (parameters['partial_discount_allowed']?.value as boolean) ?? true,
  };
};